var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxLaptopChartLine = function Svg18PxLaptopChartLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#18px_laptop-chart-line_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.75 7.5-2.146 2.146a.5.5 0 0 1-.707 0L8.104 7.853a.5.5 0 0 0-.707 0L5.251 9.999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 14.75a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h9.5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2M.75 14.75h16.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "18px_laptop-chart-line_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default Svg18PxLaptopChartLine;